/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * NOFOMO REST API
 * REST API. Stage: development.
 * OpenAPI spec version: 1.37.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ApplePayCheckout,
  ApplePayCheckoutInput,
  Cart,
  CartCreateInput,
  CartUpdateInput,
  CheckoutPaymentActions,
  DeleteLoyaltyBurnPointsParams,
  Event,
  EventCategories,
  EventLowestPrice,
  EventTickets,
  GeneratingTickets,
  GetEventLowestPriceParams,
  GetEventParams,
  GetEventTicketsParams,
  GetGeneratingTicketsParams,
  GetSellerListingsParams,
  GetTicketOffersByCodeParams,
  GetTicketsInfoBody,
  LoyaltyBurnPointsInput,
  LoyaltyEffects,
  LoyaltySession,
  MarketplaceListing,
  Order,
  OrderCheckout,
  OrderCreateInput,
  PayoutRequests,
  SellerAccount,
  SellerBankAccount,
  SellerBankAccountCreateInput,
  SellerKycDocument,
  SellerKycDocumentCreateInput,
  SellerKycDocumentUploadLink,
  SellerKycDocumentUploadLinkInput,
  SellerListedUpdateStatusBody,
  SellerListedUpdateStatusResponse,
  SellerListingsPaginated,
  SellerSignupInput,
  ServerTime,
  SimulateLoyaltyCartUpdateInput,
  TabbyPrescoring,
  TabbyPrescoringInput,
  Ticket,
  TicketDownloadUrl,
  TicketOfferCategories,
  TicketsInfo,
  Transfer,
  TransferAcceptInput,
  TransferByShareCode,
  TransferCancelInput,
  TransferCreateInput,
} from '../nofomoRestApi.schemas';

import { restfulRequester } from '../../client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export type createCartResponse201 = {
  data: Cart;
  status: 201;
};

export type createCartResponse400 = {
  data: void;
  status: 400;
};

export type createCartResponse401 = {
  data: void;
  status: 401;
};

export type createCartResponseSuccess = createCartResponse201 & {
  headers: Headers;
};
export type createCartResponseError = (
  | createCartResponse400
  | createCartResponse401
) & {
  headers: Headers;
};

export type createCartResponse =
  | createCartResponseSuccess
  | createCartResponseError;

export const getCreateCartUrl = (eventId: string) => {
  return `/tickets/events/${eventId}/carts`;
};

/**
 * @summary Create a cart
 */
export const createCart = async (
  eventId: string,
  cartCreateInput: CartCreateInput,
  options?: RequestInit,
): Promise<createCartResponse> => {
  return restfulRequester<createCartResponse>(getCreateCartUrl(eventId), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cartCreateInput),
  });
};

export const getCreateCartMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCart>>,
    TError,
    { eventId: string; data: CartCreateInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCart>>,
  TError,
  { eventId: string; data: CartCreateInput },
  TContext
> => {
  const mutationKey = ['createCart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCart>>,
    { eventId: string; data: CartCreateInput }
  > = (props) => {
    const { eventId, data } = props ?? {};

    return createCart(eventId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCartMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCart>>
>;
export type CreateCartMutationBody = CartCreateInput;
export type CreateCartMutationError = void;

/**
 * @summary Create a cart
 */
export const useCreateCart = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCart>>,
      TError,
      { eventId: string; data: CartCreateInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createCart>>,
  TError,
  { eventId: string; data: CartCreateInput },
  TContext
> => {
  return useMutation(getCreateCartMutationOptions(options), queryClient);
};
export type getCartResponse200 = {
  data: Cart;
  status: 200;
};

export type getCartResponse401 = {
  data: void;
  status: 401;
};

export type getCartResponse404 = {
  data: void;
  status: 404;
};

export type getCartResponseSuccess = getCartResponse200 & {
  headers: Headers;
};
export type getCartResponseError = (getCartResponse401 | getCartResponse404) & {
  headers: Headers;
};

export type getCartResponse = getCartResponseSuccess | getCartResponseError;

export const getGetCartUrl = (eventId: string, cartId: string) => {
  return `/tickets/events/${eventId}/carts/${cartId}`;
};

/**
 * @summary Get a cart
 */
export const getCart = async (
  eventId: string,
  cartId: string,
  options?: RequestInit,
): Promise<getCartResponse> => {
  return restfulRequester<getCartResponse>(getGetCartUrl(eventId, cartId), {
    ...options,
    method: 'GET',
  });
};

export const getGetCartQueryKey = (eventId: string, cartId: string) => {
  return [`/tickets/events/${eventId}/carts/${cartId}`] as const;
};

export const getGetCartQueryOptions = <
  TData = Awaited<ReturnType<typeof getCart>>,
  TError = void,
>(
  eventId: string,
  cartId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCartQueryKey(eventId, cartId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCart>>> = ({
    signal,
  }) => getCart(eventId, cartId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      eventId !== null &&
      eventId !== undefined &&
      cartId !== null &&
      cartId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetCartQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCart>>
>;
export type GetCartQueryError = void;

export function useGetCart<
  TData = Awaited<ReturnType<typeof getCart>>,
  TError = void,
>(
  eventId: string,
  cartId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCart>>,
          TError,
          Awaited<ReturnType<typeof getCart>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCart<
  TData = Awaited<ReturnType<typeof getCart>>,
  TError = void,
>(
  eventId: string,
  cartId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCart>>,
          TError,
          Awaited<ReturnType<typeof getCart>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCart<
  TData = Awaited<ReturnType<typeof getCart>>,
  TError = void,
>(
  eventId: string,
  cartId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a cart
 */

export function useGetCart<
  TData = Awaited<ReturnType<typeof getCart>>,
  TError = void,
>(
  eventId: string,
  cartId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCart>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCartQueryOptions(eventId, cartId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type updateCartResponse200 = {
  data: Cart;
  status: 200;
};

export type updateCartResponse400 = {
  data: void;
  status: 400;
};

export type updateCartResponse401 = {
  data: void;
  status: 401;
};

export type updateCartResponse404 = {
  data: void;
  status: 404;
};

export type updateCartResponseSuccess = updateCartResponse200 & {
  headers: Headers;
};
export type updateCartResponseError = (
  | updateCartResponse400
  | updateCartResponse401
  | updateCartResponse404
) & {
  headers: Headers;
};

export type updateCartResponse =
  | updateCartResponseSuccess
  | updateCartResponseError;

export const getUpdateCartUrl = (eventId: string, cartId: string) => {
  return `/tickets/events/${eventId}/carts/${cartId}`;
};

/**
 * @summary Update a cart
 */
export const updateCart = async (
  eventId: string,
  cartId: string,
  cartUpdateInput: CartUpdateInput,
  options?: RequestInit,
): Promise<updateCartResponse> => {
  return restfulRequester<updateCartResponse>(
    getUpdateCartUrl(eventId, cartId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(cartUpdateInput),
    },
  );
};

export const getUpdateCartMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCart>>,
    TError,
    { eventId: string; cartId: string; data: CartUpdateInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCart>>,
  TError,
  { eventId: string; cartId: string; data: CartUpdateInput },
  TContext
> => {
  const mutationKey = ['updateCart'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCart>>,
    { eventId: string; cartId: string; data: CartUpdateInput }
  > = (props) => {
    const { eventId, cartId, data } = props ?? {};

    return updateCart(eventId, cartId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCartMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCart>>
>;
export type UpdateCartMutationBody = CartUpdateInput;
export type UpdateCartMutationError = void;

/**
 * @summary Update a cart
 */
export const useUpdateCart = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCart>>,
      TError,
      { eventId: string; cartId: string; data: CartUpdateInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCart>>,
  TError,
  { eventId: string; cartId: string; data: CartUpdateInput },
  TContext
> => {
  return useMutation(getUpdateCartMutationOptions(options), queryClient);
};
export type getTicketDownloadUrlResponse200 = {
  data: TicketDownloadUrl;
  status: 200;
};

export type getTicketDownloadUrlResponse401 = {
  data: void;
  status: 401;
};

export type getTicketDownloadUrlResponseSuccess =
  getTicketDownloadUrlResponse200 & {
    headers: Headers;
  };
export type getTicketDownloadUrlResponseError =
  getTicketDownloadUrlResponse401 & {
    headers: Headers;
  };

export type getTicketDownloadUrlResponse =
  | getTicketDownloadUrlResponseSuccess
  | getTicketDownloadUrlResponseError;

export const getGetTicketDownloadUrlUrl = (pdfTicketId: string) => {
  return `/tickets/download/${pdfTicketId}`;
};

/**
 * @summary Get a one-time download link for a PDF ticket
 */
export const getTicketDownloadUrl = async (
  pdfTicketId: string,
  options?: RequestInit,
): Promise<getTicketDownloadUrlResponse> => {
  return restfulRequester<getTicketDownloadUrlResponse>(
    getGetTicketDownloadUrlUrl(pdfTicketId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetTicketDownloadUrlQueryKey = (pdfTicketId: string) => {
  return [`/tickets/download/${pdfTicketId}`] as const;
};

export const getGetTicketDownloadUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getTicketDownloadUrl>>,
  TError = void,
>(
  pdfTicketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketDownloadUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTicketDownloadUrlQueryKey(pdfTicketId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTicketDownloadUrl>>
  > = ({ signal }) =>
    getTicketDownloadUrl(pdfTicketId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: pdfTicketId !== null && pdfTicketId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTicketDownloadUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTicketDownloadUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTicketDownloadUrl>>
>;
export type GetTicketDownloadUrlQueryError = void;

export function useGetTicketDownloadUrl<
  TData = Awaited<ReturnType<typeof getTicketDownloadUrl>>,
  TError = void,
>(
  pdfTicketId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketDownloadUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getTicketDownloadUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTicketDownloadUrl<
  TData = Awaited<ReturnType<typeof getTicketDownloadUrl>>,
  TError = void,
>(
  pdfTicketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketDownloadUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getTicketDownloadUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTicketDownloadUrl<
  TData = Awaited<ReturnType<typeof getTicketDownloadUrl>>,
  TError = void,
>(
  pdfTicketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketDownloadUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a one-time download link for a PDF ticket
 */

export function useGetTicketDownloadUrl<
  TData = Awaited<ReturnType<typeof getTicketDownloadUrl>>,
  TError = void,
>(
  pdfTicketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketDownloadUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTicketDownloadUrlQueryOptions(
    pdfTicketId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getEventResponse200 = {
  data: Event;
  status: 200;
};

export type getEventResponse401 = {
  data: void;
  status: 401;
};

export type getEventResponse404 = {
  data: void;
  status: 404;
};

export type getEventResponseSuccess = getEventResponse200 & {
  headers: Headers;
};
export type getEventResponseError = (
  | getEventResponse401
  | getEventResponse404
) & {
  headers: Headers;
};

export type getEventResponse = getEventResponseSuccess | getEventResponseError;

export const getGetEventUrl = (id: string, params?: GetEventParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/tickets/events/${id}?${stringifiedParams}`
    : `/tickets/events/${id}`;
};

/**
 * @summary Get an event
 */
export const getEvent = async (
  id: string,
  params?: GetEventParams,
  options?: RequestInit,
): Promise<getEventResponse> => {
  return restfulRequester<getEventResponse>(getGetEventUrl(id, params), {
    ...options,
    method: 'GET',
  });
};

export const getGetEventQueryKey = (id: string, params?: GetEventParams) => {
  return [`/tickets/events/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetEventQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = void,
>(
  id: string,
  params?: GetEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({
    signal,
  }) => getEvent(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetEventQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvent>>
>;
export type GetEventQueryError = void;

export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = void,
>(
  id: string,
  params: undefined | GetEventParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = void,
>(
  id: string,
  params?: GetEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = void,
>(
  id: string,
  params?: GetEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get an event
 */

export function useGetEvent<
  TData = Awaited<ReturnType<typeof getEvent>>,
  TError = void,
>(
  id: string,
  params?: GetEventParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getEventCategoriesResponse200 = {
  data: EventCategories;
  status: 200;
};

export type getEventCategoriesResponse401 = {
  data: void;
  status: 401;
};

export type getEventCategoriesResponseSuccess =
  getEventCategoriesResponse200 & {
    headers: Headers;
  };
export type getEventCategoriesResponseError = getEventCategoriesResponse401 & {
  headers: Headers;
};

export type getEventCategoriesResponse =
  | getEventCategoriesResponseSuccess
  | getEventCategoriesResponseError;

export const getGetEventCategoriesUrl = (id: string) => {
  return `/tickets/events/${id}/categories`;
};

/**
 * @summary List ticket categories for an event
 */
export const getEventCategories = async (
  id: string,
  options?: RequestInit,
): Promise<getEventCategoriesResponse> => {
  return restfulRequester<getEventCategoriesResponse>(
    getGetEventCategoriesUrl(id),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetEventCategoriesQueryKey = (id: string) => {
  return [`/tickets/events/${id}/categories`] as const;
};

export const getGetEventCategoriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventCategories>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEventCategoriesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventCategories>>
  > = ({ signal }) => getEventCategories(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventCategories>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventCategories>>
>;
export type GetEventCategoriesQueryError = void;

export function useGetEventCategories<
  TData = Awaited<ReturnType<typeof getEventCategories>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventCategories>>,
          TError,
          Awaited<ReturnType<typeof getEventCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventCategories<
  TData = Awaited<ReturnType<typeof getEventCategories>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventCategories>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventCategories>>,
          TError,
          Awaited<ReturnType<typeof getEventCategories>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventCategories<
  TData = Awaited<ReturnType<typeof getEventCategories>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List ticket categories for an event
 */

export function useGetEventCategories<
  TData = Awaited<ReturnType<typeof getEventCategories>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventCategories>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventCategoriesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getEventLowestPriceResponse200 = {
  data: EventLowestPrice | null;
  status: 200;
};

export type getEventLowestPriceResponse401 = {
  data: void;
  status: 401;
};

export type getEventLowestPriceResponseSuccess =
  getEventLowestPriceResponse200 & {
    headers: Headers;
  };
export type getEventLowestPriceResponseError =
  getEventLowestPriceResponse401 & {
    headers: Headers;
  };

export type getEventLowestPriceResponse =
  | getEventLowestPriceResponseSuccess
  | getEventLowestPriceResponseError;

export const getGetEventLowestPriceUrl = (
  id: string,
  params?: GetEventLowestPriceParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/tickets/events/${id}/lowest-price?${stringifiedParams}`
    : `/tickets/events/${id}/lowest-price`;
};

/**
 * @summary Get the lowest available price for an event
 */
export const getEventLowestPrice = async (
  id: string,
  params?: GetEventLowestPriceParams,
  options?: RequestInit,
): Promise<getEventLowestPriceResponse> => {
  return restfulRequester<getEventLowestPriceResponse>(
    getGetEventLowestPriceUrl(id, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetEventLowestPriceQueryKey = (
  id: string,
  params?: GetEventLowestPriceParams,
) => {
  return [
    `/tickets/events/${id}/lowest-price`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEventLowestPriceQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventLowestPrice>>,
  TError = void,
>(
  id: string,
  params?: GetEventLowestPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventLowestPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEventLowestPriceQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEventLowestPrice>>
  > = ({ signal }) =>
    getEventLowestPrice(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventLowestPrice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventLowestPriceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventLowestPrice>>
>;
export type GetEventLowestPriceQueryError = void;

export function useGetEventLowestPrice<
  TData = Awaited<ReturnType<typeof getEventLowestPrice>>,
  TError = void,
>(
  id: string,
  params: undefined | GetEventLowestPriceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventLowestPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventLowestPrice>>,
          TError,
          Awaited<ReturnType<typeof getEventLowestPrice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventLowestPrice<
  TData = Awaited<ReturnType<typeof getEventLowestPrice>>,
  TError = void,
>(
  id: string,
  params?: GetEventLowestPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventLowestPrice>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventLowestPrice>>,
          TError,
          Awaited<ReturnType<typeof getEventLowestPrice>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventLowestPrice<
  TData = Awaited<ReturnType<typeof getEventLowestPrice>>,
  TError = void,
>(
  id: string,
  params?: GetEventLowestPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventLowestPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the lowest available price for an event
 */

export function useGetEventLowestPrice<
  TData = Awaited<ReturnType<typeof getEventLowestPrice>>,
  TError = void,
>(
  id: string,
  params?: GetEventLowestPriceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventLowestPrice>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventLowestPriceQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getEventTicketResponse200 = {
  data: Ticket;
  status: 200;
};

export type getEventTicketResponse401 = {
  data: void;
  status: 401;
};

export type getEventTicketResponse404 = {
  data: void;
  status: 404;
};

export type getEventTicketResponseSuccess = getEventTicketResponse200 & {
  headers: Headers;
};
export type getEventTicketResponseError = (
  | getEventTicketResponse401
  | getEventTicketResponse404
) & {
  headers: Headers;
};

export type getEventTicketResponse =
  | getEventTicketResponseSuccess
  | getEventTicketResponseError;

export const getGetEventTicketUrl = (eventId: string, ticketId: string) => {
  return `/tickets/events/${eventId}/tickets/${ticketId}`;
};

/**
 * @summary Get a single ticket from an event
 */
export const getEventTicket = async (
  eventId: string,
  ticketId: string,
  options?: RequestInit,
): Promise<getEventTicketResponse> => {
  return restfulRequester<getEventTicketResponse>(
    getGetEventTicketUrl(eventId, ticketId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetEventTicketQueryKey = (
  eventId: string,
  ticketId: string,
) => {
  return [`/tickets/events/${eventId}/tickets/${ticketId}`] as const;
};

export const getGetEventTicketQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventTicket>>,
  TError = void,
>(
  eventId: string,
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventTicket>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEventTicketQueryKey(eventId, ticketId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventTicket>>> = ({
    signal,
  }) => getEventTicket(eventId, ticketId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      eventId !== null &&
      eventId !== undefined &&
      ticketId !== null &&
      ticketId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventTicket>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventTicketQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventTicket>>
>;
export type GetEventTicketQueryError = void;

export function useGetEventTicket<
  TData = Awaited<ReturnType<typeof getEventTicket>>,
  TError = void,
>(
  eventId: string,
  ticketId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventTicket>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTicket>>,
          TError,
          Awaited<ReturnType<typeof getEventTicket>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventTicket<
  TData = Awaited<ReturnType<typeof getEventTicket>>,
  TError = void,
>(
  eventId: string,
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventTicket>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTicket>>,
          TError,
          Awaited<ReturnType<typeof getEventTicket>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventTicket<
  TData = Awaited<ReturnType<typeof getEventTicket>>,
  TError = void,
>(
  eventId: string,
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventTicket>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single ticket from an event
 */

export function useGetEventTicket<
  TData = Awaited<ReturnType<typeof getEventTicket>>,
  TError = void,
>(
  eventId: string,
  ticketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEventTicket>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventTicketQueryOptions(
    eventId,
    ticketId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getEventTicketsResponse200 = {
  data: EventTickets;
  status: 200;
};

export type getEventTicketsResponse401 = {
  data: void;
  status: 401;
};

export type getEventTicketsResponseSuccess = getEventTicketsResponse200 & {
  headers: Headers;
};
export type getEventTicketsResponseError = getEventTicketsResponse401 & {
  headers: Headers;
};

export type getEventTicketsResponse =
  | getEventTicketsResponseSuccess
  | getEventTicketsResponseError;

export const getGetEventTicketsUrl = (
  id: string,
  params?: GetEventTicketsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/tickets/events/${id}/tickets?${stringifiedParams}`
    : `/tickets/events/${id}/tickets`;
};

/**
 * @summary List tickets for an event
 */
export const getEventTickets = async (
  id: string,
  params?: GetEventTicketsParams,
  options?: RequestInit,
): Promise<getEventTicketsResponse> => {
  return restfulRequester<getEventTicketsResponse>(
    getGetEventTicketsUrl(id, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetEventTicketsQueryKey = (
  id: string,
  params?: GetEventTicketsParams,
) => {
  return [
    `/tickets/events/${id}/tickets`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEventTicketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getEventTickets>>,
  TError = void,
>(
  id: string,
  params?: GetEventTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEventTicketsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventTickets>>> = ({
    signal,
  }) => getEventTickets(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEventTickets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEventTicketsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEventTickets>>
>;
export type GetEventTicketsQueryError = void;

export function useGetEventTickets<
  TData = Awaited<ReturnType<typeof getEventTickets>>,
  TError = void,
>(
  id: string,
  params: undefined | GetEventTicketsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventTickets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTickets>>,
          TError,
          Awaited<ReturnType<typeof getEventTickets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventTickets<
  TData = Awaited<ReturnType<typeof getEventTickets>>,
  TError = void,
>(
  id: string,
  params?: GetEventTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventTickets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTickets>>,
          TError,
          Awaited<ReturnType<typeof getEventTickets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetEventTickets<
  TData = Awaited<ReturnType<typeof getEventTickets>>,
  TError = void,
>(
  id: string,
  params?: GetEventTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List tickets for an event
 */

export function useGetEventTickets<
  TData = Awaited<ReturnType<typeof getEventTickets>>,
  TError = void,
>(
  id: string,
  params?: GetEventTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEventTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetEventTicketsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getGeneratingTicketsResponse200 = {
  data: GeneratingTickets;
  status: 200;
};

export type getGeneratingTicketsResponse401 = {
  data: void;
  status: 401;
};

export type getGeneratingTicketsResponseSuccess =
  getGeneratingTicketsResponse200 & {
    headers: Headers;
  };
export type getGeneratingTicketsResponseError =
  getGeneratingTicketsResponse401 & {
    headers: Headers;
  };

export type getGeneratingTicketsResponse =
  | getGeneratingTicketsResponseSuccess
  | getGeneratingTicketsResponseError;

export const getGetGeneratingTicketsUrl = (
  params?: GetGeneratingTicketsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/tickets/events/generating-tickets?${stringifiedParams}`
    : `/tickets/events/generating-tickets`;
};

/**
 * @summary Whether the account has tickets currently being generated for the event
 */
export const getGeneratingTickets = async (
  params?: GetGeneratingTicketsParams,
  options?: RequestInit,
): Promise<getGeneratingTicketsResponse> => {
  return restfulRequester<getGeneratingTicketsResponse>(
    getGetGeneratingTicketsUrl(params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetGeneratingTicketsQueryKey = (
  params?: GetGeneratingTicketsParams,
) => {
  return [
    `/tickets/events/generating-tickets`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetGeneratingTicketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeneratingTickets>>,
  TError = void,
>(
  params?: GetGeneratingTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGeneratingTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeneratingTicketsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeneratingTickets>>
  > = ({ signal }) =>
    getGeneratingTickets(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeneratingTickets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetGeneratingTicketsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeneratingTickets>>
>;
export type GetGeneratingTicketsQueryError = void;

export function useGetGeneratingTickets<
  TData = Awaited<ReturnType<typeof getGeneratingTickets>>,
  TError = void,
>(
  params: undefined | GetGeneratingTicketsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGeneratingTickets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneratingTickets>>,
          TError,
          Awaited<ReturnType<typeof getGeneratingTickets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGeneratingTickets<
  TData = Awaited<ReturnType<typeof getGeneratingTickets>>,
  TError = void,
>(
  params?: GetGeneratingTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGeneratingTickets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeneratingTickets>>,
          TError,
          Awaited<ReturnType<typeof getGeneratingTickets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetGeneratingTickets<
  TData = Awaited<ReturnType<typeof getGeneratingTickets>>,
  TError = void,
>(
  params?: GetGeneratingTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGeneratingTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Whether the account has tickets currently being generated for the event
 */

export function useGetGeneratingTickets<
  TData = Awaited<ReturnType<typeof getGeneratingTickets>>,
  TError = void,
>(
  params?: GetGeneratingTicketsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getGeneratingTickets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetGeneratingTicketsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getTicketOffersByCodeResponse200 = {
  data: TicketOfferCategories;
  status: 200;
};

export type getTicketOffersByCodeResponse401 = {
  data: void;
  status: 401;
};

export type getTicketOffersByCodeResponseSuccess =
  getTicketOffersByCodeResponse200 & {
    headers: Headers;
  };
export type getTicketOffersByCodeResponseError =
  getTicketOffersByCodeResponse401 & {
    headers: Headers;
  };

export type getTicketOffersByCodeResponse =
  | getTicketOffersByCodeResponseSuccess
  | getTicketOffersByCodeResponseError;

export const getGetTicketOffersByCodeUrl = (
  eventId: string,
  params: GetTicketOffersByCodeParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/tickets/events/${eventId}/offers?${stringifiedParams}`
    : `/tickets/events/${eventId}/offers`;
};

/**
 * @summary Resolve a ticket-offer code into matching ticket categories
 */
export const getTicketOffersByCode = async (
  eventId: string,
  params: GetTicketOffersByCodeParams,
  options?: RequestInit,
): Promise<getTicketOffersByCodeResponse> => {
  return restfulRequester<getTicketOffersByCodeResponse>(
    getGetTicketOffersByCodeUrl(eventId, params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetTicketOffersByCodeQueryKey = (
  eventId: string,
  params?: GetTicketOffersByCodeParams,
) => {
  return [
    `/tickets/events/${eventId}/offers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTicketOffersByCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getTicketOffersByCode>>,
  TError = void,
>(
  eventId: string,
  params: GetTicketOffersByCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketOffersByCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTicketOffersByCodeQueryKey(eventId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTicketOffersByCode>>
  > = ({ signal }) =>
    getTicketOffersByCode(eventId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: eventId !== null && eventId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTicketOffersByCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTicketOffersByCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTicketOffersByCode>>
>;
export type GetTicketOffersByCodeQueryError = void;

export function useGetTicketOffersByCode<
  TData = Awaited<ReturnType<typeof getTicketOffersByCode>>,
  TError = void,
>(
  eventId: string,
  params: GetTicketOffersByCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketOffersByCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketOffersByCode>>,
          TError,
          Awaited<ReturnType<typeof getTicketOffersByCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTicketOffersByCode<
  TData = Awaited<ReturnType<typeof getTicketOffersByCode>>,
  TError = void,
>(
  eventId: string,
  params: GetTicketOffersByCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketOffersByCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTicketOffersByCode>>,
          TError,
          Awaited<ReturnType<typeof getTicketOffersByCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTicketOffersByCode<
  TData = Awaited<ReturnType<typeof getTicketOffersByCode>>,
  TError = void,
>(
  eventId: string,
  params: GetTicketOffersByCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketOffersByCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Resolve a ticket-offer code into matching ticket categories
 */

export function useGetTicketOffersByCode<
  TData = Awaited<ReturnType<typeof getTicketOffersByCode>>,
  TError = void,
>(
  eventId: string,
  params: GetTicketOffersByCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTicketOffersByCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTicketOffersByCodeQueryOptions(
    eventId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getTicketsInfoResponse200 = {
  data: TicketsInfo;
  status: 200;
};

export type getTicketsInfoResponse401 = {
  data: void;
  status: 401;
};

export type getTicketsInfoResponseSuccess = getTicketsInfoResponse200 & {
  headers: Headers;
};
export type getTicketsInfoResponseError = getTicketsInfoResponse401 & {
  headers: Headers;
};

export type getTicketsInfoResponse =
  | getTicketsInfoResponseSuccess
  | getTicketsInfoResponseError;

export const getGetTicketsInfoUrl = (eventId: string) => {
  return `/tickets/events/${eventId}/tickets/info`;
};

/**
 * @summary Fetch availability + pricing for a set of tickets
 */
export const getTicketsInfo = async (
  eventId: string,
  getTicketsInfoBody?: GetTicketsInfoBody,
  options?: RequestInit,
): Promise<getTicketsInfoResponse> => {
  return restfulRequester<getTicketsInfoResponse>(
    getGetTicketsInfoUrl(eventId),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(getTicketsInfoBody),
    },
  );
};

export const getGetTicketsInfoMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getTicketsInfo>>,
    TError,
    { eventId: string; data?: GetTicketsInfoBody },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getTicketsInfo>>,
  TError,
  { eventId: string; data?: GetTicketsInfoBody },
  TContext
> => {
  const mutationKey = ['getTicketsInfo'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getTicketsInfo>>,
    { eventId: string; data?: GetTicketsInfoBody }
  > = (props) => {
    const { eventId, data } = props ?? {};

    return getTicketsInfo(eventId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetTicketsInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof getTicketsInfo>>
>;
export type GetTicketsInfoMutationBody = GetTicketsInfoBody | undefined;
export type GetTicketsInfoMutationError = void;

/**
 * @summary Fetch availability + pricing for a set of tickets
 */
export const useGetTicketsInfo = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getTicketsInfo>>,
      TError,
      { eventId: string; data?: GetTicketsInfoBody },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getTicketsInfo>>,
  TError,
  { eventId: string; data?: GetTicketsInfoBody },
  TContext
> => {
  return useMutation(getGetTicketsInfoMutationOptions(options), queryClient);
};
export type createLoyaltyBurnPointsResponse200 = {
  data: Cart;
  status: 200;
};

export type createLoyaltyBurnPointsResponse400 = {
  data: void;
  status: 400;
};

export type createLoyaltyBurnPointsResponse401 = {
  data: void;
  status: 401;
};

export type createLoyaltyBurnPointsResponse404 = {
  data: void;
  status: 404;
};

export type createLoyaltyBurnPointsResponseSuccess =
  createLoyaltyBurnPointsResponse200 & {
    headers: Headers;
  };
export type createLoyaltyBurnPointsResponseError = (
  | createLoyaltyBurnPointsResponse400
  | createLoyaltyBurnPointsResponse401
  | createLoyaltyBurnPointsResponse404
) & {
  headers: Headers;
};

export type createLoyaltyBurnPointsResponse =
  | createLoyaltyBurnPointsResponseSuccess
  | createLoyaltyBurnPointsResponseError;

export const getCreateLoyaltyBurnPointsUrl = () => {
  return `/tickets/loyalty/burn`;
};

/**
 * @summary Apply Saudi Rewards burn points to a cart
 */
export const createLoyaltyBurnPoints = async (
  loyaltyBurnPointsInput: LoyaltyBurnPointsInput,
  options?: RequestInit,
): Promise<createLoyaltyBurnPointsResponse> => {
  return restfulRequester<createLoyaltyBurnPointsResponse>(
    getCreateLoyaltyBurnPointsUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(loyaltyBurnPointsInput),
    },
  );
};

export const getCreateLoyaltyBurnPointsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLoyaltyBurnPoints>>,
    TError,
    { data: LoyaltyBurnPointsInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLoyaltyBurnPoints>>,
  TError,
  { data: LoyaltyBurnPointsInput },
  TContext
> => {
  const mutationKey = ['createLoyaltyBurnPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLoyaltyBurnPoints>>,
    { data: LoyaltyBurnPointsInput }
  > = (props) => {
    const { data } = props ?? {};

    return createLoyaltyBurnPoints(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLoyaltyBurnPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLoyaltyBurnPoints>>
>;
export type CreateLoyaltyBurnPointsMutationBody = LoyaltyBurnPointsInput;
export type CreateLoyaltyBurnPointsMutationError = void;

/**
 * @summary Apply Saudi Rewards burn points to a cart
 */
export const useCreateLoyaltyBurnPoints = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createLoyaltyBurnPoints>>,
      TError,
      { data: LoyaltyBurnPointsInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createLoyaltyBurnPoints>>,
  TError,
  { data: LoyaltyBurnPointsInput },
  TContext
> => {
  return useMutation(
    getCreateLoyaltyBurnPointsMutationOptions(options),
    queryClient,
  );
};
export type deleteLoyaltyBurnPointsResponse200 = {
  data: Cart;
  status: 200;
};

export type deleteLoyaltyBurnPointsResponse400 = {
  data: void;
  status: 400;
};

export type deleteLoyaltyBurnPointsResponse401 = {
  data: void;
  status: 401;
};

export type deleteLoyaltyBurnPointsResponse404 = {
  data: void;
  status: 404;
};

export type deleteLoyaltyBurnPointsResponseSuccess =
  deleteLoyaltyBurnPointsResponse200 & {
    headers: Headers;
  };
export type deleteLoyaltyBurnPointsResponseError = (
  | deleteLoyaltyBurnPointsResponse400
  | deleteLoyaltyBurnPointsResponse401
  | deleteLoyaltyBurnPointsResponse404
) & {
  headers: Headers;
};

export type deleteLoyaltyBurnPointsResponse =
  | deleteLoyaltyBurnPointsResponseSuccess
  | deleteLoyaltyBurnPointsResponseError;

export const getDeleteLoyaltyBurnPointsUrl = (
  params: DeleteLoyaltyBurnPointsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/tickets/loyalty/burn?${stringifiedParams}`
    : `/tickets/loyalty/burn`;
};

/**
 * @summary Remove Saudi Rewards burn points from a cart
 */
export const deleteLoyaltyBurnPoints = async (
  params: DeleteLoyaltyBurnPointsParams,
  options?: RequestInit,
): Promise<deleteLoyaltyBurnPointsResponse> => {
  return restfulRequester<deleteLoyaltyBurnPointsResponse>(
    getDeleteLoyaltyBurnPointsUrl(params),
    {
      ...options,
      method: 'DELETE',
    },
  );
};

export const getDeleteLoyaltyBurnPointsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLoyaltyBurnPoints>>,
    TError,
    { params: DeleteLoyaltyBurnPointsParams },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLoyaltyBurnPoints>>,
  TError,
  { params: DeleteLoyaltyBurnPointsParams },
  TContext
> => {
  const mutationKey = ['deleteLoyaltyBurnPoints'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLoyaltyBurnPoints>>,
    { params: DeleteLoyaltyBurnPointsParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteLoyaltyBurnPoints(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLoyaltyBurnPointsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLoyaltyBurnPoints>>
>;

export type DeleteLoyaltyBurnPointsMutationError = void;

/**
 * @summary Remove Saudi Rewards burn points from a cart
 */
export const useDeleteLoyaltyBurnPoints = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteLoyaltyBurnPoints>>,
      TError,
      { params: DeleteLoyaltyBurnPointsParams },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLoyaltyBurnPoints>>,
  TError,
  { params: DeleteLoyaltyBurnPointsParams },
  TContext
> => {
  return useMutation(
    getDeleteLoyaltyBurnPointsMutationOptions(options),
    queryClient,
  );
};
export type getLoyaltySessionResponse200 = {
  data: LoyaltySession;
  status: 200;
};

export type getLoyaltySessionResponse401 = {
  data: void;
  status: 401;
};

export type getLoyaltySessionResponse404 = {
  data: void;
  status: 404;
};

export type getLoyaltySessionResponseSuccess = getLoyaltySessionResponse200 & {
  headers: Headers;
};
export type getLoyaltySessionResponseError = (
  | getLoyaltySessionResponse401
  | getLoyaltySessionResponse404
) & {
  headers: Headers;
};

export type getLoyaltySessionResponse =
  | getLoyaltySessionResponseSuccess
  | getLoyaltySessionResponseError;

export const getGetLoyaltySessionUrl = (cartId: string) => {
  return `/tickets/loyalty/sessions/${cartId}`;
};

/**
 * @summary Get loyalty progress for a cart session
 */
export const getLoyaltySession = async (
  cartId: string,
  options?: RequestInit,
): Promise<getLoyaltySessionResponse> => {
  return restfulRequester<getLoyaltySessionResponse>(
    getGetLoyaltySessionUrl(cartId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetLoyaltySessionQueryKey = (cartId: string) => {
  return [`/tickets/loyalty/sessions/${cartId}`] as const;
};

export const getGetLoyaltySessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getLoyaltySession>>,
  TError = void,
>(
  cartId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoyaltySession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLoyaltySessionQueryKey(cartId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLoyaltySession>>
  > = ({ signal }) => getLoyaltySession(cartId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: cartId !== null && cartId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getLoyaltySession>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLoyaltySessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLoyaltySession>>
>;
export type GetLoyaltySessionQueryError = void;

export function useGetLoyaltySession<
  TData = Awaited<ReturnType<typeof getLoyaltySession>>,
  TError = void,
>(
  cartId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoyaltySession>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltySession>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltySession>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoyaltySession<
  TData = Awaited<ReturnType<typeof getLoyaltySession>>,
  TError = void,
>(
  cartId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoyaltySession>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoyaltySession>>,
          TError,
          Awaited<ReturnType<typeof getLoyaltySession>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLoyaltySession<
  TData = Awaited<ReturnType<typeof getLoyaltySession>>,
  TError = void,
>(
  cartId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoyaltySession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get loyalty progress for a cart session
 */

export function useGetLoyaltySession<
  TData = Awaited<ReturnType<typeof getLoyaltySession>>,
  TError = void,
>(
  cartId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLoyaltySession>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLoyaltySessionQueryOptions(cartId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type simulateLoyaltyCartUpdateResponse200 = {
  data: LoyaltyEffects;
  status: 200;
};

export type simulateLoyaltyCartUpdateResponse400 = {
  data: void;
  status: 400;
};

export type simulateLoyaltyCartUpdateResponse401 = {
  data: void;
  status: 401;
};

export type simulateLoyaltyCartUpdateResponse404 = {
  data: void;
  status: 404;
};

export type simulateLoyaltyCartUpdateResponseSuccess =
  simulateLoyaltyCartUpdateResponse200 & {
    headers: Headers;
  };
export type simulateLoyaltyCartUpdateResponseError = (
  | simulateLoyaltyCartUpdateResponse400
  | simulateLoyaltyCartUpdateResponse401
  | simulateLoyaltyCartUpdateResponse404
) & {
  headers: Headers;
};

export type simulateLoyaltyCartUpdateResponse =
  | simulateLoyaltyCartUpdateResponseSuccess
  | simulateLoyaltyCartUpdateResponseError;

export const getSimulateLoyaltyCartUpdateUrl = () => {
  return `/tickets/loyalty/simulate`;
};

/**
 * @summary Simulate loyalty effects for a cart update
 */
export const simulateLoyaltyCartUpdate = async (
  simulateLoyaltyCartUpdateInput: SimulateLoyaltyCartUpdateInput,
  options?: RequestInit,
): Promise<simulateLoyaltyCartUpdateResponse> => {
  return restfulRequester<simulateLoyaltyCartUpdateResponse>(
    getSimulateLoyaltyCartUpdateUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(simulateLoyaltyCartUpdateInput),
    },
  );
};

export const getSimulateLoyaltyCartUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof simulateLoyaltyCartUpdate>>,
    TError,
    { data: SimulateLoyaltyCartUpdateInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof simulateLoyaltyCartUpdate>>,
  TError,
  { data: SimulateLoyaltyCartUpdateInput },
  TContext
> => {
  const mutationKey = ['simulateLoyaltyCartUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof simulateLoyaltyCartUpdate>>,
    { data: SimulateLoyaltyCartUpdateInput }
  > = (props) => {
    const { data } = props ?? {};

    return simulateLoyaltyCartUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SimulateLoyaltyCartUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof simulateLoyaltyCartUpdate>>
>;
export type SimulateLoyaltyCartUpdateMutationBody =
  SimulateLoyaltyCartUpdateInput;
export type SimulateLoyaltyCartUpdateMutationError = void;

/**
 * @summary Simulate loyalty effects for a cart update
 */
export const useSimulateLoyaltyCartUpdate = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof simulateLoyaltyCartUpdate>>,
      TError,
      { data: SimulateLoyaltyCartUpdateInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof simulateLoyaltyCartUpdate>>,
  TError,
  { data: SimulateLoyaltyCartUpdateInput },
  TContext
> => {
  return useMutation(
    getSimulateLoyaltyCartUpdateMutationOptions(options),
    queryClient,
  );
};
export type getServerTimeResponse200 = {
  data: ServerTime;
  status: 200;
};

export type getServerTimeResponse401 = {
  data: void;
  status: 401;
};

export type getServerTimeResponseSuccess = getServerTimeResponse200 & {
  headers: Headers;
};
export type getServerTimeResponseError = getServerTimeResponse401 & {
  headers: Headers;
};

export type getServerTimeResponse =
  | getServerTimeResponseSuccess
  | getServerTimeResponseError;

export const getGetServerTimeUrl = () => {
  return `/tickets/time`;
};

/**
 * @summary Get server time
 */
export const getServerTime = async (
  options?: RequestInit,
): Promise<getServerTimeResponse> => {
  return restfulRequester<getServerTimeResponse>(getGetServerTimeUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetServerTimeQueryKey = () => {
  return [`/tickets/time`] as const;
};

export const getGetServerTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof getServerTime>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getServerTime>>, TError, TData>
  >;
  request?: SecondParameter<typeof restfulRequester>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetServerTimeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getServerTime>>> = ({
    signal,
  }) => getServerTime({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getServerTime>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetServerTimeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getServerTime>>
>;
export type GetServerTimeQueryError = void;

export function useGetServerTime<
  TData = Awaited<ReturnType<typeof getServerTime>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getServerTime>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServerTime>>,
          TError,
          Awaited<ReturnType<typeof getServerTime>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetServerTime<
  TData = Awaited<ReturnType<typeof getServerTime>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getServerTime>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServerTime>>,
          TError,
          Awaited<ReturnType<typeof getServerTime>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetServerTime<
  TData = Awaited<ReturnType<typeof getServerTime>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getServerTime>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get server time
 */

export function useGetServerTime<
  TData = Awaited<ReturnType<typeof getServerTime>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getServerTime>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetServerTimeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type cancelOrderResponse204 = {
  data: void;
  status: 204;
};

export type cancelOrderResponse401 = {
  data: void;
  status: 401;
};

export type cancelOrderResponse404 = {
  data: void;
  status: 404;
};

export type cancelOrderResponseSuccess = cancelOrderResponse204 & {
  headers: Headers;
};
export type cancelOrderResponseError = (
  | cancelOrderResponse401
  | cancelOrderResponse404
) & {
  headers: Headers;
};

export type cancelOrderResponse =
  | cancelOrderResponseSuccess
  | cancelOrderResponseError;

export const getCancelOrderUrl = (orderId: string) => {
  return `/tickets/orders/${orderId}/cancel`;
};

/**
 * @summary Cancel an order
 */
export const cancelOrder = async (
  orderId: string,
  options?: RequestInit,
): Promise<cancelOrderResponse> => {
  return restfulRequester<cancelOrderResponse>(getCancelOrderUrl(orderId), {
    ...options,
    method: 'POST',
  });
};

export const getCancelOrderMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelOrder>>,
    TError,
    { orderId: string },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelOrder>>,
  TError,
  { orderId: string },
  TContext
> => {
  const mutationKey = ['cancelOrder'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelOrder>>,
    { orderId: string }
  > = (props) => {
    const { orderId } = props ?? {};

    return cancelOrder(orderId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelOrder>>
>;

export type CancelOrderMutationError = void;

/**
 * @summary Cancel an order
 */
export const useCancelOrder = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelOrder>>,
      TError,
      { orderId: string },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelOrder>>,
  TError,
  { orderId: string },
  TContext
> => {
  return useMutation(getCancelOrderMutationOptions(options), queryClient);
};
export type createOrderResponse201 = {
  data: OrderCheckout;
  status: 201;
};

export type createOrderResponse400 = {
  data: void;
  status: 400;
};

export type createOrderResponse401 = {
  data: void;
  status: 401;
};

export type createOrderResponseSuccess = createOrderResponse201 & {
  headers: Headers;
};
export type createOrderResponseError = (
  | createOrderResponse400
  | createOrderResponse401
) & {
  headers: Headers;
};

export type createOrderResponse =
  | createOrderResponseSuccess
  | createOrderResponseError;

export const getCreateOrderUrl = () => {
  return `/tickets/orders`;
};

/**
 * @summary Create an order from a cart
 */
export const createOrder = async (
  orderCreateInput: OrderCreateInput,
  options?: RequestInit,
): Promise<createOrderResponse> => {
  return restfulRequester<createOrderResponse>(getCreateOrderUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(orderCreateInput),
  });
};

export const getCreateOrderMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrder>>,
    TError,
    { data: OrderCreateInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { data: OrderCreateInput },
  TContext
> => {
  const mutationKey = ['createOrder'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrder>>,
    { data: OrderCreateInput }
  > = (props) => {
    const { data } = props ?? {};

    return createOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrder>>
>;
export type CreateOrderMutationBody = OrderCreateInput;
export type CreateOrderMutationError = void;

/**
 * @summary Create an order from a cart
 */
export const useCreateOrder = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrder>>,
      TError,
      { data: OrderCreateInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { data: OrderCreateInput },
  TContext
> => {
  return useMutation(getCreateOrderMutationOptions(options), queryClient);
};
export type getOrderResponse200 = {
  data: Order;
  status: 200;
};

export type getOrderResponse401 = {
  data: void;
  status: 401;
};

export type getOrderResponse404 = {
  data: void;
  status: 404;
};

export type getOrderResponseSuccess = getOrderResponse200 & {
  headers: Headers;
};
export type getOrderResponseError = (
  | getOrderResponse401
  | getOrderResponse404
) & {
  headers: Headers;
};

export type getOrderResponse = getOrderResponseSuccess | getOrderResponseError;

export const getGetOrderUrl = (orderId: string) => {
  return `/tickets/orders/${orderId}`;
};

/**
 * @summary Get an order
 */
export const getOrder = async (
  orderId: string,
  options?: RequestInit,
): Promise<getOrderResponse> => {
  return restfulRequester<getOrderResponse>(getGetOrderUrl(orderId), {
    ...options,
    method: 'GET',
  });
};

export const getGetOrderQueryKey = (orderId: string) => {
  return [`/tickets/orders/${orderId}`] as const;
};

export const getGetOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = void,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({
    signal,
  }) => getOrder(orderId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: orderId !== null && orderId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrder>>
>;
export type GetOrderQueryError = void;

export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = void,
>(
  orderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrder>>,
          TError,
          Awaited<ReturnType<typeof getOrder>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = void,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrder>>,
          TError,
          Awaited<ReturnType<typeof getOrder>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = void,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get an order
 */

export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = void,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrderQueryOptions(orderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type createApplePayCheckoutResponse200 = {
  data: ApplePayCheckout;
  status: 200;
};

export type createApplePayCheckoutResponse400 = {
  data: void;
  status: 400;
};

export type createApplePayCheckoutResponse401 = {
  data: void;
  status: 401;
};

export type createApplePayCheckoutResponseSuccess =
  createApplePayCheckoutResponse200 & {
    headers: Headers;
  };
export type createApplePayCheckoutResponseError = (
  | createApplePayCheckoutResponse400
  | createApplePayCheckoutResponse401
) & {
  headers: Headers;
};

export type createApplePayCheckoutResponse =
  | createApplePayCheckoutResponseSuccess
  | createApplePayCheckoutResponseError;

export const getCreateApplePayCheckoutUrl = () => {
  return `/tickets/payments/apple-pay`;
};

/**
 * @summary Capture an Apple Pay checkout payment
 */
export const createApplePayCheckout = async (
  applePayCheckoutInput: ApplePayCheckoutInput,
  options?: RequestInit,
): Promise<createApplePayCheckoutResponse> => {
  return restfulRequester<createApplePayCheckoutResponse>(
    getCreateApplePayCheckoutUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(applePayCheckoutInput),
    },
  );
};

export const getCreateApplePayCheckoutMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApplePayCheckout>>,
    TError,
    { data: ApplePayCheckoutInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createApplePayCheckout>>,
  TError,
  { data: ApplePayCheckoutInput },
  TContext
> => {
  const mutationKey = ['createApplePayCheckout'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createApplePayCheckout>>,
    { data: ApplePayCheckoutInput }
  > = (props) => {
    const { data } = props ?? {};

    return createApplePayCheckout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApplePayCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createApplePayCheckout>>
>;
export type CreateApplePayCheckoutMutationBody = ApplePayCheckoutInput;
export type CreateApplePayCheckoutMutationError = void;

/**
 * @summary Capture an Apple Pay checkout payment
 */
export const useCreateApplePayCheckout = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createApplePayCheckout>>,
      TError,
      { data: ApplePayCheckoutInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createApplePayCheckout>>,
  TError,
  { data: ApplePayCheckoutInput },
  TContext
> => {
  return useMutation(
    getCreateApplePayCheckoutMutationOptions(options),
    queryClient,
  );
};
export type createTabbyPrescoringResponse200 = {
  data: TabbyPrescoring;
  status: 200;
};

export type createTabbyPrescoringResponse400 = {
  data: void;
  status: 400;
};

export type createTabbyPrescoringResponse401 = {
  data: void;
  status: 401;
};

export type createTabbyPrescoringResponseSuccess =
  createTabbyPrescoringResponse200 & {
    headers: Headers;
  };
export type createTabbyPrescoringResponseError = (
  | createTabbyPrescoringResponse400
  | createTabbyPrescoringResponse401
) & {
  headers: Headers;
};

export type createTabbyPrescoringResponse =
  | createTabbyPrescoringResponseSuccess
  | createTabbyPrescoringResponseError;

export const getCreateTabbyPrescoringUrl = () => {
  return `/tickets/payments/tabby/prescore`;
};

/**
 * @summary Run Tabby prescoring for a cart
 */
export const createTabbyPrescoring = async (
  tabbyPrescoringInput: TabbyPrescoringInput,
  options?: RequestInit,
): Promise<createTabbyPrescoringResponse> => {
  return restfulRequester<createTabbyPrescoringResponse>(
    getCreateTabbyPrescoringUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(tabbyPrescoringInput),
    },
  );
};

export const getCreateTabbyPrescoringMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTabbyPrescoring>>,
    TError,
    { data: TabbyPrescoringInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTabbyPrescoring>>,
  TError,
  { data: TabbyPrescoringInput },
  TContext
> => {
  const mutationKey = ['createTabbyPrescoring'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTabbyPrescoring>>,
    { data: TabbyPrescoringInput }
  > = (props) => {
    const { data } = props ?? {};

    return createTabbyPrescoring(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTabbyPrescoringMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTabbyPrescoring>>
>;
export type CreateTabbyPrescoringMutationBody = TabbyPrescoringInput;
export type CreateTabbyPrescoringMutationError = void;

/**
 * @summary Run Tabby prescoring for a cart
 */
export const useCreateTabbyPrescoring = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTabbyPrescoring>>,
      TError,
      { data: TabbyPrescoringInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTabbyPrescoring>>,
  TError,
  { data: TabbyPrescoringInput },
  TContext
> => {
  return useMutation(
    getCreateTabbyPrescoringMutationOptions(options),
    queryClient,
  );
};
export type getCheckoutPaymentActionsResponse200 = {
  data: CheckoutPaymentActions;
  status: 200;
};

export type getCheckoutPaymentActionsResponse401 = {
  data: void;
  status: 401;
};

export type getCheckoutPaymentActionsResponse404 = {
  data: void;
  status: 404;
};

export type getCheckoutPaymentActionsResponseSuccess =
  getCheckoutPaymentActionsResponse200 & {
    headers: Headers;
  };
export type getCheckoutPaymentActionsResponseError = (
  | getCheckoutPaymentActionsResponse401
  | getCheckoutPaymentActionsResponse404
) & {
  headers: Headers;
};

export type getCheckoutPaymentActionsResponse =
  | getCheckoutPaymentActionsResponseSuccess
  | getCheckoutPaymentActionsResponseError;

export const getGetCheckoutPaymentActionsUrl = (paymentId: string) => {
  return `/tickets/payments/${paymentId}/actions`;
};

/**
 * @summary Get follow-up actions for an in-flight checkout payment
 */
export const getCheckoutPaymentActions = async (
  paymentId: string,
  options?: RequestInit,
): Promise<getCheckoutPaymentActionsResponse> => {
  return restfulRequester<getCheckoutPaymentActionsResponse>(
    getGetCheckoutPaymentActionsUrl(paymentId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetCheckoutPaymentActionsQueryKey = (paymentId: string) => {
  return [`/tickets/payments/${paymentId}/actions`] as const;
};

export const getGetCheckoutPaymentActionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
  TError = void,
>(
  paymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCheckoutPaymentActionsQueryKey(paymentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCheckoutPaymentActions>>
  > = ({ signal }) =>
    getCheckoutPaymentActions(paymentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: paymentId !== null && paymentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCheckoutPaymentActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCheckoutPaymentActions>>
>;
export type GetCheckoutPaymentActionsQueryError = void;

export function useGetCheckoutPaymentActions<
  TData = Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
  TError = void,
>(
  paymentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
          TError,
          Awaited<ReturnType<typeof getCheckoutPaymentActions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckoutPaymentActions<
  TData = Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
  TError = void,
>(
  paymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
          TError,
          Awaited<ReturnType<typeof getCheckoutPaymentActions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCheckoutPaymentActions<
  TData = Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
  TError = void,
>(
  paymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get follow-up actions for an in-flight checkout payment
 */

export function useGetCheckoutPaymentActions<
  TData = Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
  TError = void,
>(
  paymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCheckoutPaymentActions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCheckoutPaymentActionsQueryOptions(
    paymentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type createSellerBankAccountResponse201 = {
  data: SellerBankAccount;
  status: 201;
};

export type createSellerBankAccountResponse400 = {
  data: void;
  status: 400;
};

export type createSellerBankAccountResponse401 = {
  data: void;
  status: 401;
};

export type createSellerBankAccountResponse404 = {
  data: void;
  status: 404;
};

export type createSellerBankAccountResponseSuccess =
  createSellerBankAccountResponse201 & {
    headers: Headers;
  };
export type createSellerBankAccountResponseError = (
  | createSellerBankAccountResponse400
  | createSellerBankAccountResponse401
  | createSellerBankAccountResponse404
) & {
  headers: Headers;
};

export type createSellerBankAccountResponse =
  | createSellerBankAccountResponseSuccess
  | createSellerBankAccountResponseError;

export const getCreateSellerBankAccountUrl = () => {
  return `/tickets/seller/bank-account`;
};

/**
 * @summary Link a bank account to the seller profile
 */
export const createSellerBankAccount = async (
  sellerBankAccountCreateInput: SellerBankAccountCreateInput,
  options?: RequestInit,
): Promise<createSellerBankAccountResponse> => {
  return restfulRequester<createSellerBankAccountResponse>(
    getCreateSellerBankAccountUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sellerBankAccountCreateInput),
    },
  );
};

export const getCreateSellerBankAccountMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSellerBankAccount>>,
    TError,
    { data: SellerBankAccountCreateInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSellerBankAccount>>,
  TError,
  { data: SellerBankAccountCreateInput },
  TContext
> => {
  const mutationKey = ['createSellerBankAccount'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSellerBankAccount>>,
    { data: SellerBankAccountCreateInput }
  > = (props) => {
    const { data } = props ?? {};

    return createSellerBankAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSellerBankAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSellerBankAccount>>
>;
export type CreateSellerBankAccountMutationBody = SellerBankAccountCreateInput;
export type CreateSellerBankAccountMutationError = void;

/**
 * @summary Link a bank account to the seller profile
 */
export const useCreateSellerBankAccount = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSellerBankAccount>>,
      TError,
      { data: SellerBankAccountCreateInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSellerBankAccount>>,
  TError,
  { data: SellerBankAccountCreateInput },
  TContext
> => {
  return useMutation(
    getCreateSellerBankAccountMutationOptions(options),
    queryClient,
  );
};
export type getSellerBankAccountResponse200 = {
  data: SellerBankAccount;
  status: 200;
};

export type getSellerBankAccountResponse401 = {
  data: void;
  status: 401;
};

export type getSellerBankAccountResponse404 = {
  data: void;
  status: 404;
};

export type getSellerBankAccountResponseSuccess =
  getSellerBankAccountResponse200 & {
    headers: Headers;
  };
export type getSellerBankAccountResponseError = (
  | getSellerBankAccountResponse401
  | getSellerBankAccountResponse404
) & {
  headers: Headers;
};

export type getSellerBankAccountResponse =
  | getSellerBankAccountResponseSuccess
  | getSellerBankAccountResponseError;

export const getGetSellerBankAccountUrl = () => {
  return `/tickets/seller/bank-account`;
};

/**
 * @summary Get the latest seller bank account
 */
export const getSellerBankAccount = async (
  options?: RequestInit,
): Promise<getSellerBankAccountResponse> => {
  return restfulRequester<getSellerBankAccountResponse>(
    getGetSellerBankAccountUrl(),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetSellerBankAccountQueryKey = () => {
  return [`/tickets/seller/bank-account`] as const;
};

export const getGetSellerBankAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getSellerBankAccount>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSellerBankAccount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restfulRequester>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSellerBankAccountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSellerBankAccount>>
  > = ({ signal }) => getSellerBankAccount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSellerBankAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSellerBankAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSellerBankAccount>>
>;
export type GetSellerBankAccountQueryError = void;

export function useGetSellerBankAccount<
  TData = Awaited<ReturnType<typeof getSellerBankAccount>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerBankAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerBankAccount>>,
          TError,
          Awaited<ReturnType<typeof getSellerBankAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerBankAccount<
  TData = Awaited<ReturnType<typeof getSellerBankAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerBankAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerBankAccount>>,
          TError,
          Awaited<ReturnType<typeof getSellerBankAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerBankAccount<
  TData = Awaited<ReturnType<typeof getSellerBankAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerBankAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the latest seller bank account
 */

export function useGetSellerBankAccount<
  TData = Awaited<ReturnType<typeof getSellerBankAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerBankAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSellerBankAccountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type createSellerKycDocumentResponse201 = {
  data: SellerKycDocument;
  status: 201;
};

export type createSellerKycDocumentResponse400 = {
  data: void;
  status: 400;
};

export type createSellerKycDocumentResponse401 = {
  data: void;
  status: 401;
};

export type createSellerKycDocumentResponse404 = {
  data: void;
  status: 404;
};

export type createSellerKycDocumentResponseSuccess =
  createSellerKycDocumentResponse201 & {
    headers: Headers;
  };
export type createSellerKycDocumentResponseError = (
  | createSellerKycDocumentResponse400
  | createSellerKycDocumentResponse401
  | createSellerKycDocumentResponse404
) & {
  headers: Headers;
};

export type createSellerKycDocumentResponse =
  | createSellerKycDocumentResponseSuccess
  | createSellerKycDocumentResponseError;

export const getCreateSellerKycDocumentUrl = () => {
  return `/tickets/seller/kyc-documents`;
};

/**
 * @summary Create a seller KYC document record after file upload
 */
export const createSellerKycDocument = async (
  sellerKycDocumentCreateInput: SellerKycDocumentCreateInput,
  options?: RequestInit,
): Promise<createSellerKycDocumentResponse> => {
  return restfulRequester<createSellerKycDocumentResponse>(
    getCreateSellerKycDocumentUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sellerKycDocumentCreateInput),
    },
  );
};

export const getCreateSellerKycDocumentMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSellerKycDocument>>,
    TError,
    { data: SellerKycDocumentCreateInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSellerKycDocument>>,
  TError,
  { data: SellerKycDocumentCreateInput },
  TContext
> => {
  const mutationKey = ['createSellerKycDocument'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSellerKycDocument>>,
    { data: SellerKycDocumentCreateInput }
  > = (props) => {
    const { data } = props ?? {};

    return createSellerKycDocument(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSellerKycDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSellerKycDocument>>
>;
export type CreateSellerKycDocumentMutationBody = SellerKycDocumentCreateInput;
export type CreateSellerKycDocumentMutationError = void;

/**
 * @summary Create a seller KYC document record after file upload
 */
export const useCreateSellerKycDocument = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSellerKycDocument>>,
      TError,
      { data: SellerKycDocumentCreateInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSellerKycDocument>>,
  TError,
  { data: SellerKycDocumentCreateInput },
  TContext
> => {
  return useMutation(
    getCreateSellerKycDocumentMutationOptions(options),
    queryClient,
  );
};
export type createSellerKycDocumentUploadLinkResponse200 = {
  data: SellerKycDocumentUploadLink;
  status: 200;
};

export type createSellerKycDocumentUploadLinkResponse400 = {
  data: void;
  status: 400;
};

export type createSellerKycDocumentUploadLinkResponse401 = {
  data: void;
  status: 401;
};

export type createSellerKycDocumentUploadLinkResponse404 = {
  data: void;
  status: 404;
};

export type createSellerKycDocumentUploadLinkResponseSuccess =
  createSellerKycDocumentUploadLinkResponse200 & {
    headers: Headers;
  };
export type createSellerKycDocumentUploadLinkResponseError = (
  | createSellerKycDocumentUploadLinkResponse400
  | createSellerKycDocumentUploadLinkResponse401
  | createSellerKycDocumentUploadLinkResponse404
) & {
  headers: Headers;
};

export type createSellerKycDocumentUploadLinkResponse =
  | createSellerKycDocumentUploadLinkResponseSuccess
  | createSellerKycDocumentUploadLinkResponseError;

export const getCreateSellerKycDocumentUploadLinkUrl = () => {
  return `/tickets/seller/kyc-documents/upload-link`;
};

/**
 * @summary Create a presigned upload URL for a seller KYC document
 */
export const createSellerKycDocumentUploadLink = async (
  sellerKycDocumentUploadLinkInput: SellerKycDocumentUploadLinkInput,
  options?: RequestInit,
): Promise<createSellerKycDocumentUploadLinkResponse> => {
  return restfulRequester<createSellerKycDocumentUploadLinkResponse>(
    getCreateSellerKycDocumentUploadLinkUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sellerKycDocumentUploadLinkInput),
    },
  );
};

export const getCreateSellerKycDocumentUploadLinkMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSellerKycDocumentUploadLink>>,
    TError,
    { data: SellerKycDocumentUploadLinkInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSellerKycDocumentUploadLink>>,
  TError,
  { data: SellerKycDocumentUploadLinkInput },
  TContext
> => {
  const mutationKey = ['createSellerKycDocumentUploadLink'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSellerKycDocumentUploadLink>>,
    { data: SellerKycDocumentUploadLinkInput }
  > = (props) => {
    const { data } = props ?? {};

    return createSellerKycDocumentUploadLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSellerKycDocumentUploadLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSellerKycDocumentUploadLink>>
>;
export type CreateSellerKycDocumentUploadLinkMutationBody =
  SellerKycDocumentUploadLinkInput;
export type CreateSellerKycDocumentUploadLinkMutationError = void;

/**
 * @summary Create a presigned upload URL for a seller KYC document
 */
export const useCreateSellerKycDocumentUploadLink = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSellerKycDocumentUploadLink>>,
      TError,
      { data: SellerKycDocumentUploadLinkInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSellerKycDocumentUploadLink>>,
  TError,
  { data: SellerKycDocumentUploadLinkInput },
  TContext
> => {
  return useMutation(
    getCreateSellerKycDocumentUploadLinkMutationOptions(options),
    queryClient,
  );
};
export type createSellerSignupResponse201 = {
  data: SellerAccount;
  status: 201;
};

export type createSellerSignupResponse400 = {
  data: void;
  status: 400;
};

export type createSellerSignupResponse401 = {
  data: void;
  status: 401;
};

export type createSellerSignupResponseSuccess =
  createSellerSignupResponse201 & {
    headers: Headers;
  };
export type createSellerSignupResponseError = (
  | createSellerSignupResponse400
  | createSellerSignupResponse401
) & {
  headers: Headers;
};

export type createSellerSignupResponse =
  | createSellerSignupResponseSuccess
  | createSellerSignupResponseError;

export const getCreateSellerSignupUrl = () => {
  return `/tickets/seller/account`;
};

/**
 * @summary Register as a marketplace seller
 */
export const createSellerSignup = async (
  sellerSignupInput: SellerSignupInput,
  options?: RequestInit,
): Promise<createSellerSignupResponse> => {
  return restfulRequester<createSellerSignupResponse>(
    getCreateSellerSignupUrl(),
    {
      ...options,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sellerSignupInput),
    },
  );
};

export const getCreateSellerSignupMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSellerSignup>>,
    TError,
    { data: SellerSignupInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSellerSignup>>,
  TError,
  { data: SellerSignupInput },
  TContext
> => {
  const mutationKey = ['createSellerSignup'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSellerSignup>>,
    { data: SellerSignupInput }
  > = (props) => {
    const { data } = props ?? {};

    return createSellerSignup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSellerSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSellerSignup>>
>;
export type CreateSellerSignupMutationBody = SellerSignupInput;
export type CreateSellerSignupMutationError = void;

/**
 * @summary Register as a marketplace seller
 */
export const useCreateSellerSignup = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSellerSignup>>,
      TError,
      { data: SellerSignupInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createSellerSignup>>,
  TError,
  { data: SellerSignupInput },
  TContext
> => {
  return useMutation(
    getCreateSellerSignupMutationOptions(options),
    queryClient,
  );
};
export type getSellerAccountResponse200 = {
  data: SellerAccount;
  status: 200;
};

export type getSellerAccountResponse401 = {
  data: void;
  status: 401;
};

export type getSellerAccountResponse404 = {
  data: void;
  status: 404;
};

export type getSellerAccountResponseSuccess = getSellerAccountResponse200 & {
  headers: Headers;
};
export type getSellerAccountResponseError = (
  | getSellerAccountResponse401
  | getSellerAccountResponse404
) & {
  headers: Headers;
};

export type getSellerAccountResponse =
  | getSellerAccountResponseSuccess
  | getSellerAccountResponseError;

export const getGetSellerAccountUrl = () => {
  return `/tickets/seller/account`;
};

/**
 * @summary Get the authenticated seller account
 */
export const getSellerAccount = async (
  options?: RequestInit,
): Promise<getSellerAccountResponse> => {
  return restfulRequester<getSellerAccountResponse>(getGetSellerAccountUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetSellerAccountQueryKey = () => {
  return [`/tickets/seller/account`] as const;
};

export const getGetSellerAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getSellerAccount>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getSellerAccount>>, TError, TData>
  >;
  request?: SecondParameter<typeof restfulRequester>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSellerAccountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSellerAccount>>
  > = ({ signal }) => getSellerAccount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSellerAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSellerAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSellerAccount>>
>;
export type GetSellerAccountQueryError = void;

export function useGetSellerAccount<
  TData = Awaited<ReturnType<typeof getSellerAccount>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerAccount>>,
          TError,
          Awaited<ReturnType<typeof getSellerAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerAccount<
  TData = Awaited<ReturnType<typeof getSellerAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerAccount>>,
          TError,
          Awaited<ReturnType<typeof getSellerAccount>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerAccount<
  TData = Awaited<ReturnType<typeof getSellerAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get the authenticated seller account
 */

export function useGetSellerAccount<
  TData = Awaited<ReturnType<typeof getSellerAccount>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSellerAccountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getSellerAccountPayoutsResponse200 = {
  data: PayoutRequests;
  status: 200;
};

export type getSellerAccountPayoutsResponse401 = {
  data: void;
  status: 401;
};

export type getSellerAccountPayoutsResponse404 = {
  data: void;
  status: 404;
};

export type getSellerAccountPayoutsResponseSuccess =
  getSellerAccountPayoutsResponse200 & {
    headers: Headers;
  };
export type getSellerAccountPayoutsResponseError = (
  | getSellerAccountPayoutsResponse401
  | getSellerAccountPayoutsResponse404
) & {
  headers: Headers;
};

export type getSellerAccountPayoutsResponse =
  | getSellerAccountPayoutsResponseSuccess
  | getSellerAccountPayoutsResponseError;

export const getGetSellerAccountPayoutsUrl = () => {
  return `/tickets/seller/account/payouts`;
};

/**
 * @summary Get seller payout requests with listing and bank account details
 */
export const getSellerAccountPayouts = async (
  options?: RequestInit,
): Promise<getSellerAccountPayoutsResponse> => {
  return restfulRequester<getSellerAccountPayoutsResponse>(
    getGetSellerAccountPayoutsUrl(),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetSellerAccountPayoutsQueryKey = () => {
  return [`/tickets/seller/account/payouts`] as const;
};

export const getGetSellerAccountPayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSellerAccountPayouts>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getSellerAccountPayouts>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof restfulRequester>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSellerAccountPayoutsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSellerAccountPayouts>>
  > = ({ signal }) => getSellerAccountPayouts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSellerAccountPayouts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSellerAccountPayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSellerAccountPayouts>>
>;
export type GetSellerAccountPayoutsQueryError = void;

export function useGetSellerAccountPayouts<
  TData = Awaited<ReturnType<typeof getSellerAccountPayouts>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerAccountPayouts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerAccountPayouts>>,
          TError,
          Awaited<ReturnType<typeof getSellerAccountPayouts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerAccountPayouts<
  TData = Awaited<ReturnType<typeof getSellerAccountPayouts>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerAccountPayouts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerAccountPayouts>>,
          TError,
          Awaited<ReturnType<typeof getSellerAccountPayouts>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerAccountPayouts<
  TData = Awaited<ReturnType<typeof getSellerAccountPayouts>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerAccountPayouts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get seller payout requests with listing and bank account details
 */

export function useGetSellerAccountPayouts<
  TData = Awaited<ReturnType<typeof getSellerAccountPayouts>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerAccountPayouts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSellerAccountPayoutsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getSellerKycDocumentResponse200 = {
  data: SellerKycDocument;
  status: 200;
};

export type getSellerKycDocumentResponse401 = {
  data: void;
  status: 401;
};

export type getSellerKycDocumentResponse404 = {
  data: void;
  status: 404;
};

export type getSellerKycDocumentResponseSuccess =
  getSellerKycDocumentResponse200 & {
    headers: Headers;
  };
export type getSellerKycDocumentResponseError = (
  | getSellerKycDocumentResponse401
  | getSellerKycDocumentResponse404
) & {
  headers: Headers;
};

export type getSellerKycDocumentResponse =
  | getSellerKycDocumentResponseSuccess
  | getSellerKycDocumentResponseError;

export const getGetSellerKycDocumentUrl = (documentId: string) => {
  return `/tickets/seller/kyc-documents/${documentId}`;
};

/**
 * @summary Get a seller KYC document with download URL
 */
export const getSellerKycDocument = async (
  documentId: string,
  options?: RequestInit,
): Promise<getSellerKycDocumentResponse> => {
  return restfulRequester<getSellerKycDocumentResponse>(
    getGetSellerKycDocumentUrl(documentId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetSellerKycDocumentQueryKey = (documentId: string) => {
  return [`/tickets/seller/kyc-documents/${documentId}`] as const;
};

export const getGetSellerKycDocumentQueryOptions = <
  TData = Awaited<ReturnType<typeof getSellerKycDocument>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerKycDocument>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSellerKycDocumentQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSellerKycDocument>>
  > = ({ signal }) =>
    getSellerKycDocument(documentId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: documentId !== null && documentId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSellerKycDocument>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSellerKycDocumentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSellerKycDocument>>
>;
export type GetSellerKycDocumentQueryError = void;

export function useGetSellerKycDocument<
  TData = Awaited<ReturnType<typeof getSellerKycDocument>>,
  TError = void,
>(
  documentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerKycDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerKycDocument>>,
          TError,
          Awaited<ReturnType<typeof getSellerKycDocument>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerKycDocument<
  TData = Awaited<ReturnType<typeof getSellerKycDocument>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerKycDocument>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerKycDocument>>,
          TError,
          Awaited<ReturnType<typeof getSellerKycDocument>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerKycDocument<
  TData = Awaited<ReturnType<typeof getSellerKycDocument>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerKycDocument>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a seller KYC document with download URL
 */

export function useGetSellerKycDocument<
  TData = Awaited<ReturnType<typeof getSellerKycDocument>>,
  TError = void,
>(
  documentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerKycDocument>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSellerKycDocumentQueryOptions(documentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getSellerListingResponse200 = {
  data: MarketplaceListing | null;
  status: 200;
};

export type getSellerListingResponse401 = {
  data: void;
  status: 401;
};

export type getSellerListingResponse404 = {
  data: void;
  status: 404;
};

export type getSellerListingResponseSuccess = getSellerListingResponse200 & {
  headers: Headers;
};
export type getSellerListingResponseError = (
  | getSellerListingResponse401
  | getSellerListingResponse404
) & {
  headers: Headers;
};

export type getSellerListingResponse =
  | getSellerListingResponseSuccess
  | getSellerListingResponseError;

export const getGetSellerListingUrl = (eventId: string, listingId: string) => {
  return `/tickets/seller/listings/${eventId}/${listingId}`;
};

/**
 * @summary Get a seller marketplace listing
 */
export const getSellerListing = async (
  eventId: string,
  listingId: string,
  options?: RequestInit,
): Promise<getSellerListingResponse> => {
  return restfulRequester<getSellerListingResponse>(
    getGetSellerListingUrl(eventId, listingId),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetSellerListingQueryKey = (
  eventId: string,
  listingId: string,
) => {
  return [`/tickets/seller/listings/${eventId}/${listingId}`] as const;
};

export const getGetSellerListingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSellerListing>>,
  TError = void,
>(
  eventId: string,
  listingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSellerListingQueryKey(eventId, listingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSellerListing>>
  > = ({ signal }) =>
    getSellerListing(eventId, listingId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      eventId !== null &&
      eventId !== undefined &&
      listingId !== null &&
      listingId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSellerListing>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSellerListingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSellerListing>>
>;
export type GetSellerListingQueryError = void;

export function useGetSellerListing<
  TData = Awaited<ReturnType<typeof getSellerListing>>,
  TError = void,
>(
  eventId: string,
  listingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListing>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerListing>>,
          TError,
          Awaited<ReturnType<typeof getSellerListing>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerListing<
  TData = Awaited<ReturnType<typeof getSellerListing>>,
  TError = void,
>(
  eventId: string,
  listingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListing>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerListing>>,
          TError,
          Awaited<ReturnType<typeof getSellerListing>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerListing<
  TData = Awaited<ReturnType<typeof getSellerListing>>,
  TError = void,
>(
  eventId: string,
  listingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a seller marketplace listing
 */

export function useGetSellerListing<
  TData = Awaited<ReturnType<typeof getSellerListing>>,
  TError = void,
>(
  eventId: string,
  listingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListing>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSellerListingQueryOptions(
    eventId,
    listingId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getSellerListingsResponse200 = {
  data: SellerListingsPaginated;
  status: 200;
};

export type getSellerListingsResponse401 = {
  data: void;
  status: 401;
};

export type getSellerListingsResponse404 = {
  data: void;
  status: 404;
};

export type getSellerListingsResponseSuccess = getSellerListingsResponse200 & {
  headers: Headers;
};
export type getSellerListingsResponseError = (
  | getSellerListingsResponse401
  | getSellerListingsResponse404
) & {
  headers: Headers;
};

export type getSellerListingsResponse =
  | getSellerListingsResponseSuccess
  | getSellerListingsResponseError;

export const getGetSellerListingsUrl = (params?: GetSellerListingsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/tickets/seller/listings?${stringifiedParams}`
    : `/tickets/seller/listings`;
};

/**
 * @summary List marketplace listings for the authenticated seller
 */
export const getSellerListings = async (
  params?: GetSellerListingsParams,
  options?: RequestInit,
): Promise<getSellerListingsResponse> => {
  return restfulRequester<getSellerListingsResponse>(
    getGetSellerListingsUrl(params),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetSellerListingsQueryKey = (
  params?: GetSellerListingsParams,
) => {
  return [`/tickets/seller/listings`, ...(params ? [params] : [])] as const;
};

export const getGetSellerListingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSellerListings>>,
  TError = void,
>(
  params?: GetSellerListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSellerListingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSellerListings>>
  > = ({ signal }) => getSellerListings(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSellerListings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSellerListingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSellerListings>>
>;
export type GetSellerListingsQueryError = void;

export function useGetSellerListings<
  TData = Awaited<ReturnType<typeof getSellerListings>>,
  TError = void,
>(
  params: undefined | GetSellerListingsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerListings>>,
          TError,
          Awaited<ReturnType<typeof getSellerListings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerListings<
  TData = Awaited<ReturnType<typeof getSellerListings>>,
  TError = void,
>(
  params?: GetSellerListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSellerListings>>,
          TError,
          Awaited<ReturnType<typeof getSellerListings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSellerListings<
  TData = Awaited<ReturnType<typeof getSellerListings>>,
  TError = void,
>(
  params?: GetSellerListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List marketplace listings for the authenticated seller
 */

export function useGetSellerListings<
  TData = Awaited<ReturnType<typeof getSellerListings>>,
  TError = void,
>(
  params?: GetSellerListingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSellerListings>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSellerListingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type updateSellerListedStatusResponse200 = {
  data: SellerListedUpdateStatusResponse;
  status: 200;
};

export type updateSellerListedStatusResponse400 = {
  data: void;
  status: 400;
};

export type updateSellerListedStatusResponse401 = {
  data: void;
  status: 401;
};

export type updateSellerListedStatusResponse404 = {
  data: void;
  status: 404;
};

export type updateSellerListedStatusResponseSuccess =
  updateSellerListedStatusResponse200 & {
    headers: Headers;
  };
export type updateSellerListedStatusResponseError = (
  | updateSellerListedStatusResponse400
  | updateSellerListedStatusResponse401
  | updateSellerListedStatusResponse404
) & {
  headers: Headers;
};

export type updateSellerListedStatusResponse =
  | updateSellerListedStatusResponseSuccess
  | updateSellerListedStatusResponseError;

export const getUpdateSellerListedStatusUrl = (
  eventId: string,
  listingId: string,
) => {
  return `/tickets/seller/listings/${eventId}/${listingId}/status`;
};

/**
 * @summary Update a marketplace listing status
 */
export const updateSellerListedStatus = async (
  eventId: string,
  listingId: string,
  sellerListedUpdateStatusBody: SellerListedUpdateStatusBody,
  options?: RequestInit,
): Promise<updateSellerListedStatusResponse> => {
  return restfulRequester<updateSellerListedStatusResponse>(
    getUpdateSellerListedStatusUrl(eventId, listingId),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(sellerListedUpdateStatusBody),
    },
  );
};

export const getUpdateSellerListedStatusMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSellerListedStatus>>,
    TError,
    { eventId: string; listingId: string; data: SellerListedUpdateStatusBody },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSellerListedStatus>>,
  TError,
  { eventId: string; listingId: string; data: SellerListedUpdateStatusBody },
  TContext
> => {
  const mutationKey = ['updateSellerListedStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSellerListedStatus>>,
    { eventId: string; listingId: string; data: SellerListedUpdateStatusBody }
  > = (props) => {
    const { eventId, listingId, data } = props ?? {};

    return updateSellerListedStatus(eventId, listingId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSellerListedStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSellerListedStatus>>
>;
export type UpdateSellerListedStatusMutationBody = SellerListedUpdateStatusBody;
export type UpdateSellerListedStatusMutationError = void;

/**
 * @summary Update a marketplace listing status
 */
export const useUpdateSellerListedStatus = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSellerListedStatus>>,
      TError,
      {
        eventId: string;
        listingId: string;
        data: SellerListedUpdateStatusBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateSellerListedStatus>>,
  TError,
  { eventId: string; listingId: string; data: SellerListedUpdateStatusBody },
  TContext
> => {
  return useMutation(
    getUpdateSellerListedStatusMutationOptions(options),
    queryClient,
  );
};
export type acceptTransferResponse204 = {
  data: void;
  status: 204;
};

export type acceptTransferResponse400 = {
  data: void;
  status: 400;
};

export type acceptTransferResponse401 = {
  data: void;
  status: 401;
};

export type acceptTransferResponse404 = {
  data: void;
  status: 404;
};

export type acceptTransferResponseSuccess = acceptTransferResponse204 & {
  headers: Headers;
};
export type acceptTransferResponseError = (
  | acceptTransferResponse400
  | acceptTransferResponse401
  | acceptTransferResponse404
) & {
  headers: Headers;
};

export type acceptTransferResponse =
  | acceptTransferResponseSuccess
  | acceptTransferResponseError;

export const getAcceptTransferUrl = (id: string) => {
  return `/tickets/transfers/${id}/accept`;
};

/**
 * @summary Accept a pending ticket transfer
 */
export const acceptTransfer = async (
  id: string,
  transferAcceptInput: TransferAcceptInput,
  options?: RequestInit,
): Promise<acceptTransferResponse> => {
  return restfulRequester<acceptTransferResponse>(getAcceptTransferUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferAcceptInput),
  });
};

export const getAcceptTransferMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptTransfer>>,
    TError,
    { id: string; data: TransferAcceptInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptTransfer>>,
  TError,
  { id: string; data: TransferAcceptInput },
  TContext
> => {
  const mutationKey = ['acceptTransfer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptTransfer>>,
    { id: string; data: TransferAcceptInput }
  > = (props) => {
    const { id, data } = props ?? {};

    return acceptTransfer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptTransfer>>
>;
export type AcceptTransferMutationBody = TransferAcceptInput;
export type AcceptTransferMutationError = void;

/**
 * @summary Accept a pending ticket transfer
 */
export const useAcceptTransfer = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof acceptTransfer>>,
      TError,
      { id: string; data: TransferAcceptInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof acceptTransfer>>,
  TError,
  { id: string; data: TransferAcceptInput },
  TContext
> => {
  return useMutation(getAcceptTransferMutationOptions(options), queryClient);
};
export type cancelTransferResponse204 = {
  data: void;
  status: 204;
};

export type cancelTransferResponse400 = {
  data: void;
  status: 400;
};

export type cancelTransferResponse401 = {
  data: void;
  status: 401;
};

export type cancelTransferResponse404 = {
  data: void;
  status: 404;
};

export type cancelTransferResponseSuccess = cancelTransferResponse204 & {
  headers: Headers;
};
export type cancelTransferResponseError = (
  | cancelTransferResponse400
  | cancelTransferResponse401
  | cancelTransferResponse404
) & {
  headers: Headers;
};

export type cancelTransferResponse =
  | cancelTransferResponseSuccess
  | cancelTransferResponseError;

export const getCancelTransferUrl = (id: string) => {
  return `/tickets/transfers/${id}/cancel`;
};

/**
 * @summary Cancel a pending ticket transfer
 */
export const cancelTransfer = async (
  id: string,
  transferCancelInput: TransferCancelInput,
  options?: RequestInit,
): Promise<cancelTransferResponse> => {
  return restfulRequester<cancelTransferResponse>(getCancelTransferUrl(id), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferCancelInput),
  });
};

export const getCancelTransferMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelTransfer>>,
    TError,
    { id: string; data: TransferCancelInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelTransfer>>,
  TError,
  { id: string; data: TransferCancelInput },
  TContext
> => {
  const mutationKey = ['cancelTransfer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelTransfer>>,
    { id: string; data: TransferCancelInput }
  > = (props) => {
    const { id, data } = props ?? {};

    return cancelTransfer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelTransfer>>
>;
export type CancelTransferMutationBody = TransferCancelInput;
export type CancelTransferMutationError = void;

/**
 * @summary Cancel a pending ticket transfer
 */
export const useCancelTransfer = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelTransfer>>,
      TError,
      { id: string; data: TransferCancelInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelTransfer>>,
  TError,
  { id: string; data: TransferCancelInput },
  TContext
> => {
  return useMutation(getCancelTransferMutationOptions(options), queryClient);
};
export type createTransferResponse201 = {
  data: Transfer;
  status: 201;
};

export type createTransferResponse400 = {
  data: void;
  status: 400;
};

export type createTransferResponse401 = {
  data: void;
  status: 401;
};

export type createTransferResponseSuccess = createTransferResponse201 & {
  headers: Headers;
};
export type createTransferResponseError = (
  | createTransferResponse400
  | createTransferResponse401
) & {
  headers: Headers;
};

export type createTransferResponse =
  | createTransferResponseSuccess
  | createTransferResponseError;

export const getCreateTransferUrl = () => {
  return `/tickets/transfers`;
};

/**
 * @summary Create a ticket transfer
 */
export const createTransfer = async (
  transferCreateInput: TransferCreateInput,
  options?: RequestInit,
): Promise<createTransferResponse> => {
  return restfulRequester<createTransferResponse>(getCreateTransferUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferCreateInput),
  });
};

export const getCreateTransferMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTransfer>>,
    TError,
    { data: TransferCreateInput },
    TContext
  >;
  request?: SecondParameter<typeof restfulRequester>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTransfer>>,
  TError,
  { data: TransferCreateInput },
  TContext
> => {
  const mutationKey = ['createTransfer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTransfer>>,
    { data: TransferCreateInput }
  > = (props) => {
    const { data } = props ?? {};

    return createTransfer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTransfer>>
>;
export type CreateTransferMutationBody = TransferCreateInput;
export type CreateTransferMutationError = void;

/**
 * @summary Create a ticket transfer
 */
export const useCreateTransfer = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTransfer>>,
      TError,
      { data: TransferCreateInput },
      TContext
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTransfer>>,
  TError,
  { data: TransferCreateInput },
  TContext
> => {
  return useMutation(getCreateTransferMutationOptions(options), queryClient);
};
export type getTransferResponse200 = {
  data: Transfer;
  status: 200;
};

export type getTransferResponse401 = {
  data: void;
  status: 401;
};

export type getTransferResponse404 = {
  data: void;
  status: 404;
};

export type getTransferResponseSuccess = getTransferResponse200 & {
  headers: Headers;
};
export type getTransferResponseError = (
  | getTransferResponse401
  | getTransferResponse404
) & {
  headers: Headers;
};

export type getTransferResponse =
  | getTransferResponseSuccess
  | getTransferResponseError;

export const getGetTransferUrl = (id: string) => {
  return `/tickets/transfers/${id}`;
};

/**
 * @summary Get a ticket transfer
 */
export const getTransfer = async (
  id: string,
  options?: RequestInit,
): Promise<getTransferResponse> => {
  return restfulRequester<getTransferResponse>(getGetTransferUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getGetTransferQueryKey = (id: string) => {
  return [`/tickets/transfers/${id}`] as const;
};

export const getGetTransferQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransfer>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTransferQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransfer>>> = ({
    signal,
  }) => getTransfer(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransfer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTransferQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransfer>>
>;
export type GetTransferQueryError = void;

export function useGetTransfer<
  TData = Awaited<ReturnType<typeof getTransfer>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransfer>>,
          TError,
          Awaited<ReturnType<typeof getTransfer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTransfer<
  TData = Awaited<ReturnType<typeof getTransfer>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransfer>>,
          TError,
          Awaited<ReturnType<typeof getTransfer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTransfer<
  TData = Awaited<ReturnType<typeof getTransfer>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a ticket transfer
 */

export function useGetTransfer<
  TData = Awaited<ReturnType<typeof getTransfer>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTransfer>>, TError, TData>
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTransferQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export type getTransferByShareCodeResponse200 = {
  data: TransferByShareCode;
  status: 200;
};

export type getTransferByShareCodeResponse401 = {
  data: void;
  status: 401;
};

export type getTransferByShareCodeResponse404 = {
  data: void;
  status: 404;
};

export type getTransferByShareCodeResponseSuccess =
  getTransferByShareCodeResponse200 & {
    headers: Headers;
  };
export type getTransferByShareCodeResponseError = (
  | getTransferByShareCodeResponse401
  | getTransferByShareCodeResponse404
) & {
  headers: Headers;
};

export type getTransferByShareCodeResponse =
  | getTransferByShareCodeResponseSuccess
  | getTransferByShareCodeResponseError;

export const getGetTransferByShareCodeUrl = (shareCode: string) => {
  return `/tickets/transfers/share/${shareCode}`;
};

/**
 * @summary Look up a transfer by its share code
 */
export const getTransferByShareCode = async (
  shareCode: string,
  options?: RequestInit,
): Promise<getTransferByShareCodeResponse> => {
  return restfulRequester<getTransferByShareCodeResponse>(
    getGetTransferByShareCodeUrl(shareCode),
    {
      ...options,
      method: 'GET',
    },
  );
};

export const getGetTransferByShareCodeQueryKey = (shareCode: string) => {
  return [`/tickets/transfers/share/${shareCode}`] as const;
};

export const getGetTransferByShareCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getTransferByShareCode>>,
  TError = void,
>(
  shareCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferByShareCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTransferByShareCodeQueryKey(shareCode);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTransferByShareCode>>
  > = ({ signal }) =>
    getTransferByShareCode(shareCode, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: shareCode !== null && shareCode !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTransferByShareCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTransferByShareCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTransferByShareCode>>
>;
export type GetTransferByShareCodeQueryError = void;

export function useGetTransferByShareCode<
  TData = Awaited<ReturnType<typeof getTransferByShareCode>>,
  TError = void,
>(
  shareCode: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferByShareCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransferByShareCode>>,
          TError,
          Awaited<ReturnType<typeof getTransferByShareCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTransferByShareCode<
  TData = Awaited<ReturnType<typeof getTransferByShareCode>>,
  TError = void,
>(
  shareCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferByShareCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransferByShareCode>>,
          TError,
          Awaited<ReturnType<typeof getTransferByShareCode>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTransferByShareCode<
  TData = Awaited<ReturnType<typeof getTransferByShareCode>>,
  TError = void,
>(
  shareCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferByShareCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Look up a transfer by its share code
 */

export function useGetTransferByShareCode<
  TData = Awaited<ReturnType<typeof getTransferByShareCode>>,
  TError = void,
>(
  shareCode: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTransferByShareCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restfulRequester>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTransferByShareCodeQueryOptions(
    shareCode,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
